module.exports = require('./lib/static/prefixAll')



/*****************
 ** WEBPACK FOOTER
 ** ./~/inline-style-prefixer/static.js
 ** module id = 7
 ** module chunks = 0
 **/